import * as types from './types';
// eslint-disable-next-line import/no-cycle
import axios from '../../lib/axios';
import Vue from 'vue';
import {
  sourceList,
  mediaList,
} from '@/lib/enum';
import {
  errCodeMap,
} from '@/lib/errors';
import { MEDIA_TYPE_DESC } from '../../common';
// eslint-disable-next-line import/no-cycle
import api from '@/apis/settlement';
import loginApi from '@/apis/login';
import inviteApi from '@/apis/invite/index';
import commonApi from '@/apis/common';
import aegis from '@/utils/aegis';

function isBindSaas(moduleState, saasType) {
  const saasBinding = moduleState.profile.saas_binding;
  if (!saasBinding) return false;
  const saasArr = saasBinding.filter(item => item.mask === saasType);
  return !!saasArr.length && saasArr[0].has_authenticated;
}

function isBindMedia(moduleState, mediaType) {
  const mediaBinding = moduleState.profile.media_binding;
  if (!mediaBinding) return false;

  const mediaArr = mediaBinding.filter(item => item.mask === mediaType);
  return !!mediaArr.length && mediaArr[0].has_authenticated;
}

function getBindList(list = []) {
  if (!list) return [];

  return list.filter(item => item.has_authenticated === 1);
}

function getSaasInfo(moduleState) {
  const saasBinding = moduleState.profile.saas_binding;
  if (!saasBinding) return {};

  const res = {};
  saasBinding.forEach((saas) => {
    res[saas.mask] = {};
    res[saas.mask].saasId = saas.saas_id;
    res[saas.mask].bindState = isBindSaas(moduleState, saas.mask);
  });

  return res;
}

const initForm = {
  nickname: '',
  media_id: '',
  media_type: 0,
  media_name: '',
  media_mask: '',
  platform_id: 0,
  ext_info: '',
  avatar_url: '',
  state: 0,
  reason: '',
  remark: '',
  IsDelete: 0,
};

export default {
  namespaced: true,
  state: {
    // 个人基本信息
    profile: {},
    // 结算基本信息
    settlementinfo: {},
    mediaList: {
      data: [],
      pageInfo: {
        page: 1,
        count: 10,
        total: 0,
      },
    },
    inviteCode: '',
    sign: '',
    mkOpenUrl: '',
    windowshopForm: {
      ...initForm,
    },
    isShowWindowshopPop: false,
    userMediaList: [], // 用户绑定的橱窗列表，包含经营数据信息
    bindMediaInfo: {}, // 用来绑定的媒体橱窗信息
  },
  mutations: {
    [types.SET_PROFILE](state, profile) {
      state.profile = { ...state.profile, ...profile };
    },
    [types.SET_MEDIA_LIST](state, {
      list,
    }) {
      state.mediaList.data = list;
    },
    [types.SET_MEDIA_LIST_PAGE_INFO](state, payload = {}) {
      state.mediaList.pageInfo = {
        ...state.mediaList.pageInfo,
        ...payload,
      };
    },
    [types.SET_INVITE_CODE](state, {
      code, sign,
    }) {
      state.inviteCode = code;
      state.sign = sign;
    },
    [types.SET_MK_OPEN_URL](state, mkOpenUrl) {
      state.mkOpenUrl = mkOpenUrl;
    },
    [types.INIT_WINDOWSHOP_FROM](state) {
      state.windowshopForm = {
        ...initForm,
      };
    },
    [types.SET_WINDOWSHOP_FROM](state, form) {
      state.windowshopForm = {
        ...state.windowshopForm,
        ...form,
      };
    },
    [types.SET_IS_SHOW_WINDOWSHOP_POP](state, isShowWindowshopPop) {
      state.isShowWindowshopPop = isShowWindowshopPop;
    },
    [types.SET_SETTLEMENT_INFO](state, info) {
      // 设置结算信息
      if (info) {
        state.settlementinfo = { ...info };
      } else {
        state.settlementinfo = {};
      }
    },
    [types.SET_USER_MEDIA_LIST](state, list) {
      state.userMediaList = list || [];
    },
    [types.SET_BIND_MEDIA_INFO](state, data) {
      if (data) {
        // 从 sessionStorage 获取信息
        let sessionInfo = {};
        try {
          const data = window.sessionStorage.getItem('bindMediaInfo');
          if (data) {
            sessionInfo = JSON.parse(data);
          }
        } catch (err) {
          console.log(err);
        }
        let res = { ...sessionInfo, ...state.bindMediaInfo, ...data };
        const { media_type_str: mediaType, media_id: mediaId } = data;
        if (mediaType && mediaId) {
          res = {
            ...res,
            mediaType,
            mediaId,
            mediaTypeCn:
              MEDIA_TYPE_DESC[mediaType],
            icon: `https://pcgec-web-1258344701.cos.ap-shanghai.myqcloud.com/assets/e-commerce-business/global/logo/media_icon/${mediaType}.png`,
          };
        }
        state.bindMediaInfo = res;
        // 保存到 sessionStroge
        window.sessionStorage.setItem('bindMediaInfo', JSON.stringify(res));
      } else {
        window.sessionStorage.removeItem('bindMediaInfo');
        state.bindMediaInfo = {};
      }
    },
  },
  actions: {
    enterSettlement({ commit }) {
      api.enterSettlement({}).then((settlementInfo) => {
        const {
          cash,
        } = settlementInfo;
        commit('SET_SETTLEMENT_INFO', cash || {});
      });
    },

    // 获取用户信息
    async fetchCpProfile({
      commit,
    }, config = {}) {
      commit(types.SET_PROFILE, {}); // 先清空

      const { showLoading = true, autoErrorTips = true } = config;
      // 页面loading
      let loading = null;
      if (showLoading) {
        loading = Vue.prototype.$loading({
          lock: true,
          text: '加载中...',
          background: 'rgba(255, 255, 255, 0.6)',
        });
      }

      const apiPromise = loginApi.profile({}, false);
      apiPromise
        .then((res) => {
          const code = Number(res?.head?.code);
          if (code !== 0) {
            const errMsg = res?.head?.msg || '获取用户信息失败';
            autoErrorTips && Vue.prototype.$message.error(errMsg);
            return;
          }

          commit(types.SET_PROFILE, {
            ...res,

            // 为了兼容老profile接口，字段类型做一层兼容处理（老profile接口为 number 类型）
            user_id: Number(res.user_id),
            uid: Number(res.uid),
          });

          // aegis 前端日志上报，设置用户信息
          aegis.setConfig({
            uin: res.user_id, // 用户id
            ext1: JSON.stringify({
              uid: res.uid, // 中台id
              user_id: res.user_id, // 用户id
              role: res.role, // 角色id
              role_name: res.role_name, // 角色名
              identity: res.identity, // 身份类型，个人/企业
            }),
          });
        }).catch((err) => {
          const errMsg = err?.message || '获取用户信息失败';
          autoErrorTips && Vue.prototype.$message.error(errMsg);
        })
        .finally(() => {
          // 关闭loading
          loading && loading.close();
        });

      return apiPromise;
    },

    async fetchUserMediaList({
      commit,
    }) {
      let list = [];
      try {
        const reqData = {
          block_by_eshop: true, // true 只展示ESHOP可展示的用户橱窗；false 展示所有用户橱窗
          media_type: undefined, // String, 指定筛选的媒体类型，如：kg、om、qq，默认不筛选，非必传字段
        };
        const res = await commonApi.getMediaList(reqData, false);
        const code = Number(res?.head?.code);
        if (code !== 0) {
          const errorMsg = `[${code}] 获取橱窗列表失败：${res?.head?.msg}`;
          Vue.prototype.$message.error(errorMsg);
          return;
        };

        list = res?.media_infos || [];
        commit(types.SET_MEDIA_LIST, {
          list,
        });
      } catch (err) {
        const errorMsg = `[${err?.code}] 获取橱窗列表失败：${err?.message}`;
        Vue.prototype.$message.error(errorMsg);
      }

      return list;
    },

    async fetchInviteCode({
      commit,
      rootState,
    }, {
      userId,
    } = {}) {
      try {
        const reqData = {
          user_id: String(userId || rootState.userCenter.profile.user_id),
          uid: String(rootState.userCenter.profile.uid),
        };
        const res = await inviteApi.inviteGetCode(reqData);
        const code = Number(res?.head?.code);
        if (code !== 0) {
          const errorMsg = `[${code}] 获取邀请链接失败：${res?.head?.msg}`;
          Vue.prototype.$message.error(errorMsg);
          return;
        };

        commit(types.SET_INVITE_CODE, {
          code: res.code,
          sign: res.sign,
        });
      } catch (err) {
        const errorMsg = `[${err?.code}] 获取邀请链接失败：${err?.message}`;
        Vue.prototype.$message.error(errorMsg);
      }
    },

    async updateWindowshopInfo({ commit, dispatch }) {
      commit(types.SET_IS_SHOW_WINDOWSHOP_POP, false);
      dispatch('fetchUserMediaList');
    },
    async fetchUserList({
      rootState,
    }) {
      const data = {
        method: 'post',
        body: {
          user_id: String(rootState.userCenter.profile.user_id),
          page: 1,
          count: 10,
        },
      };

      const res = await axios
        .post('v1/cp/user/authority/management', data)
        .catch(() => {
          Vue.prototype.$tip.error('获取员工列表失败');
        });

      if (res.code !== 0) {
        Vue.prototype.$tip.error(errCodeMap[res.code] || '获取员工列表失败');

        return;
      }
    },
  },
  getters: {
    saasInfo: state => getSaasInfo(state),
    nickname: (state) => {
      const {
        role,
        name,
      } = state.profifle;
      if (role === 100) return '待后台下发的机构名或个人姓名';
      if (role === 100 || role === 200 || role === 201) return '待后台下发的被邀请时填写的昵称';
      return name;
    },
    isBindKg: state => isBindMedia(state, 'kg'),
    isBindWs: state => isBindMedia(state, 'ws'),
    isBindOm: state => isBindMedia(state, 'om'),
    isBindQq: state => isBindMedia(state, 'qq'),
    isBindJd: state => isBindSaas(state, 'jd'),
    isBindMk: state => isBindSaas(state, 'mk'),
    isBindPdd: state => isBindSaas(state, 'pdd'),
    // 已绑定saas列表
    openSaasList: (state) => {
      const bindList = getBindList(state.profile.saas_binding);

      return bindList.map((item) => {
        const mapItem = sourceList.find(match => match.value === item.mask);
        return mapItem;
      }).filter(item => !!item);
    },
    // 已绑定媒体列表
    openMediaList: (state) => {
      const bindList = getBindList(state.profile.media_binding);

      return bindList.map((item) => {
        const mapItem = mediaList.find(match => match.value === item.mask);
        return mapItem;
      }).filter(item => !!item);
    },
    bindMediaInfo: (state) => {
      let sessionInfo = {};
      const sessionBindInfo = window.sessionStorage.getItem('bindMediaInfo');
      if (sessionBindInfo) {
        // 拦截 parse 报错
        try {
          sessionInfo = JSON.parse(sessionBindInfo);
        } catch (err) {
          console.log(err);
        }
      }
      return state.bindMediaInfo || sessionInfo;
    },
  },
};
